﻿import * as types from './mutation-types';
import * as addressService from '../api/addresslookup';
import basketService from '../api/basket';
import productService from '../api/products';
import checkoutService from '../api/checkout';

export const saveCheckoutInfo = ({ commit, state }, parameters) => {
    checkoutService.saveInfo(parameters.ajaxUrl,
        parameters.data,
        (data) => this.cartUpdateFailed = !data.success,
        () => { alert('fail'); }
    );
}
